import {CSSProperties, memo, useMemo} from "react";
import {CELL_SIZE} from "../../utility/types";
import {Camera} from "../../utility/camera";

const SVG = encodeURIComponent(
  `<svg width="${CELL_SIZE}" height="${CELL_SIZE}" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="${CELL_SIZE}" height="${CELL_SIZE}" patternUnits="userSpaceOnUse"><path d="M ${CELL_SIZE} 0 L 0 0 0 ${CELL_SIZE}" fill="none" stroke="#000000" stroke-width="2" vector-effect="non-scaling-stroke" shape-rendering="crispEdges" /></pattern></defs><rect width="100%" height="100%" fill="url(#grid)"/></svg>`,
);

export const BackgroundGrid = memo(({camera}: {camera: Camera}) => {
  const style = useMemo<CSSProperties>(
    () => ({
      position: "absolute",
      pointerEvents: "none",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url("data:image/svg+xml,${SVG}")`,
      backgroundSize: `${CELL_SIZE * camera.zoomFactor}px ${CELL_SIZE * camera.zoomFactor}px`,
      backgroundPosition: `${camera.size.x / 2 - camera.position.x * camera.zoomFactor}px ${
        camera.size.y / 2 - camera.position.y * camera.zoomFactor
      }px`,
      opacity: 0.1,
    }),
    [camera.position.x, camera.position.y, camera.size.x, camera.size.y, camera.zoomFactor],
  );

  return <div style={style} />;
});
